/**
 * @Author Valon.Ye
 * @Date 2022/11/25 11:58:12
 * @FilePath \business\src\utils\hooks\useAppReference.ts
 * @Description
 */
import { useEffect } from 'react'

import { useLocalStorageState, useCookieState } from 'ahooks'

import StorageMap from '@/utils/storageMap'

export enum AppReferEnum {
  COMMON = 'platform',
  SSC = 'ssc',
  SSM = 'ssm',
}

const useAppReference = (type: AppReferEnum) => {
  const [appRefer, setAppRefer] = useLocalStorageState<AppReferEnum>(StorageMap.APP_REFER)
  const [appReferCookie, setAppReferCookie] = useCookieState(StorageMap.APP_REFER)

  useEffect(() => {
    if (appRefer === type && appReferCookie === type) return
    setAppRefer(type)
    setAppReferCookie(type)
  }, [])

  return {
    appRefer,
    appReferCookie,
    setAppReferCookie,
    setAppRefer,
  }
}

export const useAppReferenceWithCommerce = () => {
  return useAppReference(AppReferEnum.SSC)
}

export default useAppReferenceWithCommerce
